<script lang="ts">
  import { Card, CardContent } from "$lib/components/ui/card";
  import { routes } from "$lib/routes";
  import { sidePanelStore } from "$lib/stores/sidePanelStore";
  import { tableStore } from "$lib/stores/table-store";
  import { cn } from "$lib/utils";
</script>

<Card class="w-full space-y-3 border-0 bg-theme-background-primary p-1 font-normal text-theme-text-primary">
  <CardContent class="flex flex-col gap-2 p-2">
    <h3 class="text-xs font-normal uppercase text-theme-green-medium">Credits</h3>

    <span class="text-xs">{$sidePanelStore.credits?.toLocaleString()} credits remaining</span>
    <div class="flex items-center justify-between text-xs text-slate-700">
      <button
        onclick={() => {
          tableStore.setShowSubscriptionDialog(true, {
            title: "Plans and Pricing",
            description: "Upgrade for Additional Credits.",
          });
        }}
        class={cn(
          "flex h-7 px-3 items-center justify-center !rounded-base border-1 border-theme-text-primary text-xs focus:outline-none focus:ring-0 ",
          " border-transparent bg-theme-green-medium font-medium text-white dark:bg-theme-green-bright dark:text-black",
        )}>Upgrade</button
      >
      <a href={routes.settings} class="text-slate-500 hover:underline">View billing</a>
    </div>
  </CardContent>
</Card>
